import { Button, Card, Text } from "../../../../components";
import Localization from "../../../../localization";
import { CustomerForm } from "./customer";
import styled from "styled-components";
import { Flex } from "antd";
import React from "react";

const Styled = styled.div`
  .ant-card-head-title {
    color: ${(_) => _.theme.token.fontColors.secondary};
  }
  .ant-card-body {
    padding: 1em;
  }
  .ant-card-head {
    background: ${(_) => _.theme.token.colorPrimary};
  }
  .customer-form-item {
    width: 100%;
    border-radius: 0.5em;
    padding: 0.2em 0.5em;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
`;

const details = [
  {
    title: Localization.service_edit_alarm_operator.summary_detail_1_title,
    value: Localization.service_edit_alarm_operator.summary_detail_1_desc,
  },
  {
    title: Localization.service_edit_alarm_operator.summary_detail_2_title,
    value: Localization.service_edit_alarm_operator.summary_detail_2_desc,
  },
  {
    title: Localization.service_edit_alarm_operator.summary_detail_3_title,
    value: Localization.service_edit_alarm_operator.summary_detail_3_desc,
  },
];

const Item = ({ title = "", gap = "1.5rem", children, items }) => (
  <Card bordered classNames={{ body: "p-20 p-25-b" }}>
    <Text level={5} weight={700} className="m-20-b" children={title} />
    {Array.isArray(items) && (
      <Flex vertical gap={gap}>
        {React.Children.toArray(
          items.map((_) => (
            <div>
              <Text
                weight={600}
                type="secondary"
                className="m-5-b"
                children={_.title}
              />
              {React.Children.toArray(
                _.values.map((_, index) => (
                  <Text
                    weight={400}
                    children={_}
                    type="secondary"
                    className={`m-${!index ? 0 : 7}-t`}
                  />
                ))
              )}
            </div>
          ))
        )}
      </Flex>
    )}
    {children}
  </Card>
);

const Summary = ({
  actions = [],
  customer = {},
  contacts = [],
  onDone = () => {},
  onBack = () => {},
}) => {
  return (
    <Styled>
      <Text
        level={5}
        weight={700}
        type="secondary"
        children={`${Localization.general.step} 4: ${Localization.service_edit_alarm_operator.summary}`}
      />
      <Flex className="m-30-v" vertical gap={"2rem"}>
        <Item title={Localization.service_edit_alarm_operator.step1_title}>
        <CustomerForm
            customer={customer}
            renderFormItem={({ label, value }) => (
            <div>
              <Text type="secondary" weight={600} children={label} />
              <Text
                type="secondary"
                children={value || Localization.general.na}
              />
            </div>
          )}
        />
        </Item>

        <Item
          gap="2rem"
          title={Localization.service_edit_alarm_operator.contacts_table_title}
          items={contacts.map((_) => ({
            title: _.title,
            values: [_.phone, _.codeWord],
          }))}
        />

        <Item
          title={Localization.service_edit_alarm_operator.actions_title}
          items={actions.map((_) => ({ title: _.title, values: [_.value] }))}
        />
      </Flex>

      <Flex
        vertical
        gap={"2.5rem"}
        children={React.Children.toArray(
          details.map((_) => (
            <div>
              <Text
                level={5}
                weight={700}
                className="m-5-b"
                children={_.title}
              />
              <Text type="secondary" children={_.value} />
            </div>
          ))
        )}
      />

      <Flex gap={"1rem"} className="m-30-t">
        <Button
          type="primary"
          title={Localization.general.done}
          onClick={() => onDone()}
        />
        <Button onClick={() => onBack()} title={Localization.general.back} />
      </Flex>
    </Styled>
  );
};

export default Summary;
